import { Spinner } from '@intentsify/ui';
import '@intentsify/ui/dist/ui.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LogRocket from 'logrocket';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import './styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const PageLoader = () => (
  <div className="flex items-center justify-center h-screen">
    <Spinner className="size-40" />
  </div>
);

const AudienceExplorer = lazy(() =>
  import('./AudienceExplorer').then((m) => ({
    default: m.AudienceExplorer,
  })),
);

const UserFacingApp = () => (
  <AppLayout>
    <Suspense fallback={<PageLoader />}>
      <Outlet />
    </Suspense>
  </AppLayout>
);

const router = createBrowserRouter([
  {
    path: '/',
    Component: UserFacingApp,
    children: [
      { index: true, Component: AudienceExplorer },
      { path: ':criteria/', Component: AudienceExplorer },
      { path: ':criteria/:segmentId', Component: AudienceExplorer },
    ],
  },
]);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

if (import.meta.env.NODE_ENV === 'production') {
  LogRocket.init('absoo3/webapp');
}

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
);
